<template>
	<div class="tabWrapper accountTabAllUsersComments">
		<no-info
				v-if="accountRequestList && accountRequestList.length <= 0"
				text="The information is not filled in, please fill in the user information"
		/>

		<div v-else class="main">
			<main-table
					padding="0"
					:flag="flag"
					:headers="getHeaders"
					:listItems="accountRequestList"
					:filtersList="accountRequestFilters"
					@updateClickButton="onClickButton($event, flag)"
					@updateSearch="onFilter"
					@updateRefreshFilters="onFilter"
					@updateChangeSort="onFilter"
					@updateStatusSwitch="onStatusSwitch"
					:is-hide-header="false"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { TEXT, TITLE } from "@/constants/constants";
import { accountTabVacation } from "@/pages/Account/constants";
import NoInfo from "@/shared/NoInfo/NoInfo.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";

export default {
	name: "AccountTabVacation",
	components: { DialogRemove, NoInfo },
	computed: {
		...mapGetters([
			'accountRequestList',
			'accountRequestFilters',
		]),
		getHeaders() {
			return accountTabVacation;
		},
	},

	data: () => ({
		flag: 'AccountTabVacation',
		list: [],
		activeItem: null,
		activeIndex: null,

		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
	}),

	methods: {
		...mapActions([
			'getAccountVacationRequestList',
			'getAccountVacationRequestFilter',
			'getAccountUpdateVacationRequest',
			'deleteAccountVacationRequest',
		]),
		onClickButton({ key, item, index }) {
			this.activeItem = item;
			this.activeIndex = index;
			if (key === 'deleteMod') {
				const title = TITLE.DELETE_VACATION;
				const text = TEXT.DELETE_VACATION;
				this.onRemoveDialog({ title, text });

			}
			if (key === 'editMod') {
				this.$emit('updateVacationRequest', item);
			}
		},

		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},

		onCloseRemove() {
			this.isDialogRemove = false;
		},

		async onRemove() {
			const { id } = this.activeItem;
			await this.deleteAccountVacationRequest(id);
			this.onCloseRemove();
		},

		async onFilter({ filterModList }) {
			await this.getAccountVacationRequestFilter(filterModList);
		},

		async onStatusSwitch({ line, cancel }) {
			const { id } = line;
			const head_status = !cancel ? Number(line.head_status) : 0;
			const main_status = !cancel ? Number(line.main_status) : 0;
			const refused = Number(line.refused);
			const requestData = { id, head_status, main_status, refused };
			await this.getAccountUpdateVacationRequest(requestData);
			if (cancel) await this.getAccountVacationRequestList();
		}
	},
	async mounted() {
		await this.getAccountVacationRequestList();
	}
};
</script>

<style scoped lang="scss"></style>
